type TemplateDtoAttributes = {
    subject: string,
    templateKey: string,
    content: string,
    templateType: string,
    buttonLabel: string
    defaultFromEmail: string,
    defaultBccEmail: string,
    name: string,
    fromName: string,
    attachPdfByDefault: boolean,
    status: string,
}

export type TemplateDto = {
    id: string,
    type: string,
    attributes: TemplateDtoAttributes
}

export default class Template {
    private dto: TemplateDto
    constructor(dto: TemplateDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "email-templates"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): object {
        return this.dto.attributes
    }

    getSubject(): string {
        return this.dto.attributes.subject
    }

    getTemplateKey(): string {
        return this.dto.attributes.templateKey
    }

    getContent(): string {
        return this.dto.attributes.content
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getStatus(): string {
        return this.dto.attributes.status
    }

    getFromName(): string {
        return this.dto.attributes.fromName
    }

    getDefaultBcc(): string {
        return this.dto.attributes.defaultBccEmail
    }

    getFromEmail(): string {
        return this.dto.attributes.defaultFromEmail
    }

    getButtonLabel(): string {
        return this.dto.attributes.buttonLabel
    }

    getAttachPdfByDefault(): boolean {
        return this.dto.attributes.attachPdfByDefault
    }
}


// WEBPACK FOOTER //
// ./src/state/template/Template.ts